<template lang="pug">
.sv-button(
    :class="classes"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
)
    button.sv-button__button(
        v-on="$listeners"
    )
        .sv-button__prepend-icon(
            v-if="prependIcon"
        )
            slot(
                name="prepend-icon"
            )
                SvIcon(
                    :icon="prependIcon.icon"
                    :width="prependIcon.width"
                    :height="prependIcon.height"
                    :stroke="isOver ? prependIcon.hover : prependIcon.default"
                    :fill="isOver ? prependIcon.fillHover : prependIcon.fillDefault"
                )

        .sv-button__text(
            v-if="!icon"
        )
            | {{ text }}
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'SvButton',

  components: {
    SvIcon,
  },

  props: {
    view: {
      type: String,
      default: 'main',
    },

    text: {
      type: String,
      default: 'Buttons',
    },

    prependIcon: {
      type: Object,
      default: null,
    },

    icon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOver: false,
    };
  },

  computed: {
    viewClass() {
      return `sv-button--${this.view}`;
    },

    classes() {
      return {
        [this.viewClass]: true,
        'sv-button--icon': this.icon,
      };
    },
  },

  methods: {
    mouseover() {
      this.isOver = true;
    },

    mouseleave() {
      this.isOver = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-button {
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;

    &.sv-button--link {
        .sv-button__button {
            color: #0882DB;
            border: 0;
            outline: none;
            padding: 0;
            display: flex;
            justify-content: center;
            margin: 0;
            background-color: transparent;
            cursor: pointer;
            font-size: 14px;
        }
    }

    &.sv-button--main-small,
    &.sv-button--main {
        .sv-button__button {
            background-color: #1993EB;
            border-radius: 5px;
            color: #FFFFFF;
            text-shadow: 0px 0px 1px rgba(255, 255, 255, 0.5);
            height: 50px;
            font-size: 16px;
            line-height: 22px;
            border: 0;
            display: flex;
            padding: 0;
            width: 100%;
            font-weight: bold;
            justify-content: center;
            outline: none;
            cursor: pointer;
            align-items: center;
            user-select: none;
            transition: background-color ease-in-out .2s;

            &:hover {
                background-color: #0882DB;
            }

            &:active {
                background-color: #0379CE;
            }
        }
    }

    &.sv-button--main-small {
        .sv-button__button {
            height: 40px;
            font-size: 14px;
        }
    }

    &.sv-button--big {
        .sv-button__button {
            border: 0;
            display: flex;
            background: linear-gradient(180deg, #2DA6FE 0%, #007AD2 100%);
            box-shadow: 0px 5px 20px rgba(18, 140, 228, 0.3);
            border-radius: 50px;
            height: 60px;
            color: #fff;
            padding: 0;
            font-size: 16px;
            font-weight: bold;
            outline: none;
            cursor: pointer;
            align-items: center;
            user-select: none;
            transition: background ease-in-out .2s;

            &:hover {
                background: linear-gradient(180deg, #2A9FF4 0%, #0074C9 100%);
            }

            &:active {
                background: linear-gradient(180deg, #158ADF 0%, #158ADF 100%);
                box-shadow: 0px 5px 10px rgba(18, 140, 228, 0.35);
            }
        }

        .sv-button__prepend-icon {
            height: 35px;
            display: flex;
            align-items: center;
            padding-right: 21px;
            padding-left: 25px;
            border-right: 1px solid rgba(255, 255, 255, .3);
            margin-right: 23px;
        }

        .sv-button__text {
            margin-right: 27px;
        }
    }

    &.sv-button--flat {
        .sv-button__button {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            padding: 0;
            background: #EBF5FD;
            border-radius: 5px;
            color: #0882DB;
            border: 0;
            font-weight: bold;
            cursor: pointer;
            outline: none;
            user-select: none;
            font-size: 16px;
            transition: background ease-in-out .2s;

            &:hover {
                background: #DDF1FF;
            }

            &:active {
                background: #D2EAFC;
            }
        }

        .sv-button__prepend-icon {
            margin-left: 39px;
            margin-right: 10px;
        }

        .sv-button__text {
            margin-right: 43px;
        }
    }

    &.sv-button--bordered {
        .sv-button__button {
            border-radius: 5px;
            border: 1px solid #CDCDD9;
            font-size: 14px;
            font-weight: bold;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 0 35px;
            color: #0882DB;
            background: #fff;
            cursor: pointer;
            user-select: none;
            outline: none;
            transition: background ease-in-out .2s border-color ease-in-out .2s;
            width: max-content;

            &:hover {
                border-color: #1993EB;
            }

            &:active {
                background: #F4FAFE;
                border-color: #1993EB;
            }
        }

    }

    &.sv-button--shadow {
        .sv-button__button {
            font-weight: 500 !important;
        }
        &.sv-button--icon {
            .sv-button__button {
                padding: 0;
                width: 40px;
            }
        }

        .sv-button__button {
            border: 0;
            height: 40px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 30px;
            background: #FFFFFF;
            box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
            border-radius: 5px;
            color: #0882DB;
            transition: opacity ease-in-out .2s box-shadow ease-in-out .2s;
            font-weight: bold;
            outline: none;

            &:hover {
                opacity: .9;
            }

            &:active {
                transform: translateY(2px);
                opacity: .9;
                box-shadow: 0px 5px 10px rgba(3, 62, 105, 0.08);
            }
        }
    }

    &.sv-button--secondary {
        .sv-button__button {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 38px;
            padding: 0 15px 0 13px;
            transition: background-color ease-in-out .2s;
            background: transparent;
            border: 0;
            color: #ADB2C0;
            font-weight: bold;
            border-radius: 50px;
            outline: none;
        }

        .sv-button__text {
            margin-left: 7px;
        }

        &:hover {
            .sv-button__button {
                color: #404450;
                background-color: #EDEDF4;
            }
        }

        &:active {
            .sv-button__button {
                background-color: #E4E4EB;
            }
        }
    }

    &.sv-button--primary {
        .sv-button__button {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 38px;
            font-size: 16px;
            padding: 0 15px 0 13px;
            background: transparent;
            border: 0;
            color: rgba(8, 130, 219, .9);
            font-weight: bold;
            border-radius: 50px;
            outline: none;
            transition: background-color ease-in-out .2s;
        }

        .sv-button__text {
            margin-left: 7px;
        }

        &:hover {
            .sv-button__button {
                background-color: rgba(25, 147, 235, .1);
            }
        }

        &:active {
            .sv-button__button {
                background-color: rgba(25, 147, 235, .18);
            }
        }
    }

    &.sv-button--secondary-icon {
        .sv-button__button {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            width: 40px;
            border: 0;
            background: #F3F3F6;
            border-radius: 5px;
            outline: none;
            transition: background ease-in-out .2s;
        }

        &:active {
            .sv-button__button {
                background: #ECECF4;
            }
        }
    }

    &.sv-button--primary-icon {
        .sv-button__button {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            width: 40px;
            border: 0;
            background: transparent;
            border-radius: 5px;
            outline: none;
            transition: background ease-in-out .2s;
        }

        &:active {
            .sv-button__button {
                background: #ECECF4;
            }
        }
    }
}
</style>
